import Marquee from "react-fast-marquee";

const WORDS = ["Ceramic Coatings", "Paint Correction", "Window Tint", "Paint Protection Film", "Marine", "RV & Motorhome", "Undercoating", "Mobile Detailing"];

export const Ticker = () => (
  <section data-testid="editorial-marquee" className="relative py-10 md:py-14 border-y border-white/10 bg-[#07080B] overflow-hidden">
    <Marquee speed={28} gradient gradientColor="#07080B" gradientWidth={120} autoFill>
      {WORDS.map((w, i) => (
        <span key={w} className="flex items-center font-display font-black uppercase text-5xl md:text-7xl tracking-tight px-8">
          <span className={i % 2 ? "outline-text" : "chrome-text"}>{w}</span>
          <span className="ml-16 inline-block h-3 w-3 rotate-45 bg-[#1bb4f2]" />
        </span>
      ))}
    </Marquee>
  </section>
);
